/**
 * @module geo
 */
import {Store} from 'redux';
import {Observable} from 'rxjs/Observable';
import {fromPromise} from 'rxjs/observable/fromPromise';
import {setBaseLayerVisibilityCreatorP} from './actions/creators';
import {AppStore} from './store/app';
import {BaseLayer} from './types/base.layer';
// import {MapEntry} from "./map/layer/map.entry";
// import watch from "redux-watch";


/**
 * Implementing the [[BaseLayer]] type , the BaseLayerObj add method to
 * manipulate base layer
 *
 * Represents an image service resource as a layer. An BaseLayerObj retrieves
 * and displays data from image services.
 */
export class BaseLayerObj implements BaseLayer {
  public '@type': string = 'BaseLayerObj';
  /**
   * Unique id of layer
   */
  id: string;
  /**
   * Name of layer
   */
  name: string;
  /**
   * A reference to the connexion
   */
  connection: any;
  /**
   * Indicates if the layer is visible in the map view.
   *
   *
   * When false, the layer may still be added to a Map instance that is
   * referenced , but its features will not be visible in the map.
   */
  visible: boolean;
  /**
   * Opacity of layer , in percent
   */
  opacity?: number;

  protected store: Store<AppStore>;

  constructor(options: BaseLayer, store: Store<AppStore>) {
    Object.assign(this, options);
    this.id = options.id;
    this.name = options.name;
    this.connection = options.connection;
    this.visible = options.visible;
    this.store = store;
  }

  /**
   * Set the visibility of the MapEntry.
   * @param visibility thie visibility to set
   * @param   opacity the opacity to set in percent
   */
  public setVisibility(visibility: boolean, opacity?: number): Observable<any> {
    return fromPromise(setBaseLayerVisibilityCreatorP(
        {
          baseLayers: [{
            id: this.id,
            visible: visibility,
            opacity: (opacity || this.opacity)
          }]
        },
        this.store.dispatch));
  }
}


export interface HashBaseLayer {
  [key: string]: BaseLayerObj;
}

export interface HashBaseLayerVisibility {
  [key: string]: boolean;
}
